import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { pageSchemas } from "@/lib/seo/page-schema";
import { IndustriesLayoutBG } from "@/components/site/IndustriesLayoutBG";
import { INDUSTRIES_META_DESCRIPTION_BG } from "@/content/meta/IndustriesLayoutBG";

export const Route = createFileRoute("/bg/industries")({
  head: () => ({
    meta: [
      { title: "Индустрии - медиен мониторинг и анализи | Perceptica" },
      { name: "description", content: INDUSTRIES_META_DESCRIPTION_BG },
      { property: "og:title", content: "Индустрии - медиен мониторинг и анализи | Perceptica" },
      { property: "og:description", content: INDUSTRIES_META_DESCRIPTION_BG },

      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Индустрии - медиен мониторинг и анализи | Perceptica" },
      { name: "twitter:description", content: INDUSTRIES_META_DESCRIPTION_BG },
      { property: "og:url", content: "https://perceptica.com/bg/industries" },
      ...ogImageMeta("bg", "/industries"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/industries", collection: { name: "Industries we serve", description: "Industries Perceptica supports" } }),
  }),
  component: IndustriesLayoutBG,
});
